import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import { EmptyIterator_instanceqrxhm096rah7 as EmptyIterator_instance } from './CollectionsKt.mjs';
import { iterator3f5i676wpaa3g as iterator } from '../sequences/SequenceBuilder.mjs';
import { AbstractIterator1svf7vpi1lw8y as AbstractIterator } from './AbstractIterator.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instance1el8xrhi64v9a as Companion_instance,
} from './AbstractList.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  fill3hcjvebk42tyx as fill,
} from './_ArraysJs.mjs';
import { terminateCollectionToArray12671uhv05xea as terminateCollectionToArray } from './collectionJs.mjs';
import { coerceAtMost322komnqp70ag as coerceAtMost } from '../ranges/_Ranges.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkWindowSizeStep(size, step) {
  // Inline function 'kotlin.require' call
  if (!(size > 0 && step > 0)) {
    var message = !(size === step) ? 'Both size ' + size + ' and step ' + step + ' must be greater than zero.' : 'size ' + size + ' must be greater than zero.';
    throw IllegalArgumentException().o2(toString(message));
  }
}
function windowedIterator(iterator_0, size, step, partialWindows, reuseBuffer) {
  if (!iterator_0.q1())
    return EmptyIterator_instance;
  return iterator(windowedIterator$slambda(size, step, iterator_0, reuseBuffer, partialWindows));
}
var RingBuffer$iterator$1Class;
function RingBuffer$iterator$1() {
  if (RingBuffer$iterator$1Class === VOID) {
    class $ extends AbstractIterator() {
      constructor(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.yl_1 = this$0;
        super($box);
        this.wl_1 = this$0.cm_1;
        this.xl_1 = this$0.bm_1;
      }
      si() {
        if (this.wl_1 === 0) {
          this.ui();
        } else {
          this.ti(this.yl_1.zl_1[this.xl_1]);
          var tmp = this;
          var tmp0 = this.yl_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          tmp.xl_1 = (this.xl_1 + 1 | 0) % tmp0.am_1 | 0;
          this.wl_1 = this.wl_1 - 1 | 0;
        }
      }
    }
    initMetadataForClass($);
    RingBuffer$iterator$1Class = $;
  }
  return RingBuffer$iterator$1Class;
}
var RingBufferClass;
function RingBuffer() {
  if (RingBufferClass === VOID) {
    class $ extends AbstractList() {
      constructor(buffer, filledSize) {
        return new.target.dm(buffer, filledSize);
      }
      static dm(buffer, filledSize) {
        var $this = this.zi();
        $this.zl_1 = buffer;
        // Inline function 'kotlin.require' call
        if (!(filledSize >= 0)) {
          var message = 'ring buffer filled size should not be negative but it is ' + filledSize;
          throw IllegalArgumentException().o2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(filledSize <= $this.zl_1.length)) {
          var message_0 = 'ring buffer filled size: ' + filledSize + ' cannot be larger than the buffer size: ' + $this.zl_1.length;
          throw IllegalArgumentException().o2(toString(message_0));
        }
        $this.am_1 = $this.zl_1.length;
        $this.bm_1 = 0;
        $this.cm_1 = filledSize;
        return $this;
      }
      static em(capacity) {
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp$ret$0 = Array(capacity);
        return this.dm(tmp$ret$0, 0);
      }
      q2() {
        return this.cm_1;
      }
      r2(index) {
        Companion_instance.i7(index, this.cm_1);
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.bm_1 + index | 0) % this.am_1 | 0;
        return this.zl_1[tmp$ret$0];
      }
      fm() {
        return this.cm_1 === this.am_1;
      }
      p1() {
        return new (RingBuffer$iterator$1())(this);
      }
      yj(array) {
        var tmp;
        if (array.length < this.cm_1) {
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = this.cm_1;
          tmp = copyOf(array, newSize);
        } else {
          tmp = isArray(array) ? array : THROW_CCE();
        }
        var result = tmp;
        var size = this.cm_1;
        var widx = 0;
        var idx = this.bm_1;
        while (widx < size && idx < this.am_1) {
          result[widx] = this.zl_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        idx = 0;
        while (widx < size) {
          result[widx] = this.zl_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        var tmp_0 = terminateCollectionToArray(size, result);
        return isArray(tmp_0) ? tmp_0 : THROW_CCE();
      }
      i8() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.cm_1;
        var tmp$ret$0 = Array(size);
        return this.yj(tmp$ret$0);
      }
      toArray() {
        return this.i8();
      }
      gm(maxCapacity) {
        var newCapacity = coerceAtMost((this.am_1 + (this.am_1 >> 1) | 0) + 1 | 0, maxCapacity);
        var tmp;
        if (this.bm_1 === 0) {
          // Inline function 'kotlin.collections.copyOf' call
          var this_0 = this.zl_1;
          tmp = copyOf(this_0, newCapacity);
        } else {
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp$ret$1 = Array(newCapacity);
          tmp = this.yj(tmp$ret$1);
        }
        var newBuffer = tmp;
        return RingBuffer().dm(newBuffer, this.cm_1);
      }
      hm(element) {
        if (this.fm()) {
          throw IllegalStateException().o('ring buffer is full');
        }
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.bm_1 + this.cm_1 | 0) % this.am_1 | 0;
        this.zl_1[tmp$ret$0] = element;
        this.cm_1 = this.cm_1 + 1 | 0;
      }
      im(n) {
        // Inline function 'kotlin.require' call
        if (!(n >= 0)) {
          var message = "n shouldn't be negative but it is " + n;
          throw IllegalArgumentException().o2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(n <= this.cm_1)) {
          var message_0 = "n shouldn't be greater than the buffer size: n = " + n + ', size = ' + this.cm_1;
          throw IllegalArgumentException().o2(toString(message_0));
        }
        if (n > 0) {
          var start = this.bm_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          var end = (start + n | 0) % this.am_1 | 0;
          if (start > end) {
            fill(this.zl_1, null, start, this.am_1);
            fill(this.zl_1, null, 0, end);
          } else {
            fill(this.zl_1, null, start, end);
          }
          this.bm_1 = end;
          this.cm_1 = this.cm_1 - n | 0;
        }
      }
    }
    initMetadataForClass($, 'RingBuffer', VOID, VOID, [RandomAccess()]);
    RingBufferClass = $;
  }
  return RingBufferClass;
}
function windowedIterator$slambda($size, $step, $iterator, $reuseBuffer, $partialWindows) {
  return constructCallableReference(function *($this$iterator, $completion) {
    var bufferInitialCapacity = coerceAtMost($size, 1024);
    var gap = $step - $size | 0;
    var tmp;
    if (gap >= 0) {
      var buffer = ArrayList().i2(bufferInitialCapacity);
      var skip = 0;
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = $iterator;
      $l$loop: while (_iterator__ex2g4s.q1()) {
        var e = _iterator__ex2g4s.r1();
        if (skip > 0) {
          skip = skip - 1 | 0;
          continue $l$loop;
        }
        buffer.j2(e);
        if (buffer.q2() === $size) {
          yield* $this$iterator.dl(buffer, $completion);
          if ($reuseBuffer) {
            buffer.s4();
          } else
            buffer = ArrayList().i2($size);
          skip = gap;
        }
      }
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!buffer.n1()) {
        tmp_0 = $partialWindows || buffer.q2() === $size ? (yield* $this$iterator.dl(buffer, $completion)) : void 0;
      }
      tmp = tmp_0;
    } else {
      var buffer_0 = RingBuffer().em(bufferInitialCapacity);
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = $iterator;
      $l$loop_0: while (_iterator__ex2g4s_0.q1()) {
        var e_0 = _iterator__ex2g4s_0.r1();
        buffer_0.hm(e_0);
        if (buffer_0.fm()) {
          if (buffer_0.cm_1 < $size) {
            buffer_0 = buffer_0.gm($size);
            continue $l$loop_0;
          }
          yield* $this$iterator.dl($reuseBuffer ? buffer_0 : ArrayList().k2(buffer_0), $completion);
          buffer_0.im($step);
        }
      }
      var tmp_1;
      if ($partialWindows) {
        while (buffer_0.cm_1 > $step) {
          yield* $this$iterator.dl($reuseBuffer ? buffer_0 : ArrayList().k2(buffer_0), $completion);
          buffer_0.im($step);
        }
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!buffer_0.n1()) {
          tmp_2 = yield* $this$iterator.dl(buffer_0, $completion);
        }
        tmp_1 = tmp_2;
      }
      tmp = tmp_1;
    }
    return Unit_instance;
  }, 1);
}
//region block: exports
export {
  checkWindowSizeStep as checkWindowSizeStepcg5bise2nnst,
  windowedIterator as windowedIterator1l52d653czu3r,
};
//endregion

//# sourceMappingURL=SlidingWindow.mjs.map
